const tableHeaders = [
  {
    label: 'dealer-code',
    key: 'entity',
    defaultSort: true,
  },
  {
    label: 'dealer-name',
    key: 'dealerName',
    defaultSort: true,
  },
  {
    label: 'BC',
    key: 'businessCenterAbbreviation',
    defaultSort: true,
  },
  {
    label: 'sales-district',
    key: 'salesDistrict',
    defaultSort: true,
  },
  {
    label: 'service-district',
    key: 'serviceDistrict',
    defaultSort: true,
  },
  {
    label: 'sales-group',
    key: 'groupSize',
    defaultSort: true,
  },
  {
    label: 'Open Appeals',
    key: 'totalOpenAppeals',
    defaultSort: true,
  },
  {
    label: 'view',
    key: 'action',
    sortable: false,
  },
];

export default () => tableHeaders;
